import {useState, useEffect} from "react";
import {useSelector, useDispatch} from "react-redux";
import {withTranslation} from "react-i18next";
import "../center.scss";
import localOrSessionStore from "../../../_helpers/localOrSessionStore";
import variables from "../../../_constants/variables";
import {Button, Checkbox, Form, Input, Space, Tooltip,message,Upload} from "antd";
import {QuestionCircleOutlined,UploadOutlined,DownloadOutlined} from "@ant-design/icons";
import RegisterPDFCenter from "../pdf.page";

import config from "_config/config";
import {authActions, tutorAuthActions} from "../../../_actions";
import {xcService} from "../../../_services/xcService";

function StepThreeCenter(props) {
    const dispatch = useDispatch();
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const user = JSON.parse(storage.getItem(variables.USER));
    const {t, i18n} = props;
    const [form] = Form.useForm();
    const [isOk, setOk] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isContract, setContract] = useState(false);
    const [pdf, setPdf]= useState(null);
    const [values, setValues]= useState(null);
    const [year, setYear]= useState(22);
    const [ccaa, setCCAA]= useState(null);

    var actualYear = useSelector((state) => state.authReducer.actualYear);


    var pdfCenter = useSelector((state) => state.tutorAuthReducer.pdfCenter);
    var pdfCenterError = useSelector((state) => state.tutorAuthReducer.pdfCenterError);

    useEffect(() => {
        if (pdfCenter){
            setLoading(false)
            props.goTo(null, 3)
        }
        if (pdfCenterError){
            setLoading(false)
        }

    },[pdfCenter, pdfCenterError])


    useEffect(()=>{
        if (!actualYear){
            dispatch(authActions.actualYear())

        }
    },[])


    const beforeUpload = (file) => {
        const isJpgOrPng = file.type === "application/pdf";
        if (!isJpgOrPng) {
            message.error("You can only upload PDFG file!");
        }
        const isLt2M = file.size / 1024 / 1024 < 3;
        if (!isLt2M) {
            message.error("Image must smaller than 3MB!");
        }
        return isJpgOrPng && isLt2M;
    };

    const onRemove = (e) => {
        setPdf(null);

    }
    const handleChangeImg = (info) => {
        if (info.file.status === "uploading") {
            return;
        }
        if (info.file.status === "done") {
            // Get this url from response in real world.

            if (info && info.file && info.file.response) {
                setPdf(info.file.response);


            }
        }
    };



    useEffect(() => {


        xcService.get("/v1/tutor/contractemp/" + user.code).then(data => {

            if (data.data.data && data.data.data.code){
                const { setFieldsValue, getFieldValue } = form;
                try {

                    setFieldsValue({
                        passwordCenter: data.data.data.pwd,
                        passwordCenterrep: data.data.data.pwd
                    });

                }catch (e) {
                    console.error(e);
                }
            }


        })




    },[])


    const finishPassword =async (vals) => {
        if (vals){
            setValues({...props.values, ...vals})

            await xcService.getToken('/v1/year').then(({data}) => {
                setYear(+data.data)
            });
            setOk(true);
            setPdf(null);
            setContract(false);
        }
    }

    const downloadContract = () => {
        setContract(true)

    }

    const saveCenter = () => {

        values.pdf = pdf;
        values.courses = props.courses;
        values.center = props.center;
        values.xcelence = values.agreement5;
        setLoading(true);
        dispatch(tutorAuthActions.contractCenter(values));

    }
    useEffect(() => {
        if (props.center?.CodPostal) {
            xcService.get("/v1/tutor/ccaa/" + props.center?.CodPostal).then(data => {
                setCCAA(data.data)
            })
        }
    })

    const onChangeCod = (e) => {

        if (e.target.value.length > 2) {
            let mData = {code: user.code, passwordCenter: e.target.value};

            xcService.post("/v1/tutor/contractemp/3", mData).then(data => {
            })
        }
    }


    return (
        <>
        <Form className="authForm allHeightMobile"  form={form}
              onFinish={finishPassword}
              name="basic"
              layout="vertical"
              autoComplete="off"
        >
            <div >
                <div className={"centerClave"}>
                    <p>
                        <span className={"customLabel"}>{t("registercenter.clavet")}</span>&nbsp;&nbsp;
                        <Tooltip title={t("registercenter.toolclave")}>
                            <QuestionCircleOutlined />
                        </Tooltip>
                    </p>
                    <div style={{marginBottom: 16}} dangerouslySetInnerHTML={{__html: t('registercenter.claved')}} />

                    <Form.Item
                      label={t("registercenter.clavei2")}
                      name="passwordCenter"
                      rules={[
                          {
                              required: true,
                              message: t("mandatory"),
                          }
                          /*, {
                               pattern: new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$"),
                               message: t("registro.passwordRules")
                           },*/
                      ]}
                    >
                        <Input.Password placeholder={t("registercenter.clavetool")}  onChange={onChangeCod} />
                    </Form.Item>

                    <Form.Item
                      label={t("registercenter.clavei3")}
                      name="passwordCenterrep"
                      rules={[
                          {
                              required: true,
                              message: t("mandatory"),
                          }
                          ,
                          ({ getFieldValue }) => ({
                              validator(_, value) {
                                  if (!value || getFieldValue('passwordCenter') === value) {
                                      return Promise.resolve();
                                  }
                                  return Promise.reject(new Error( t("registro.passwordmis")));
                              },
                          }),
                      ]}
                    >
                        <Input.Password placeholder={t("registercenter.clavetool")} />
                    </Form.Item>
                    <div className={"customLabel customLabel-xs"}
                         style={{marginTop: 16, marginBottom: 16}}>
                        {t("registercenter.textxcelence1")} &nbsp;
                        <a href={t("registercenter.urlxcelence")}
                           target={"_blank"}
                           className={"primaryLink"}>{t("registercenter.textxcelence2")}</a>
                    </div>
                    <Form.Item
                      name="agreement5"
                      valuePropName="checked"
                    >
                        <Checkbox>
                            {t("registercenter.soy")}
                        </Checkbox>
                    </Form.Item>
                </div>
                <div className={"customLabel"}
                     style={{marginTop: 16, marginBottom: 16}}>{t("registercenter.titleterms")}</div>
                {/* ToDo : Revisar campos,*/}
                <div className={"form-item-mb-m"}>
                    <Form.Item
                      name="agreement0"
                      valuePropName="checked"
                      rules={[
                          {
                              validator: (_, value) =>
                                value ? Promise.resolve() : Promise.reject(new Error(t("registro.mustaccept"))),
                          },
                      ]}

                    >
                        <Checkbox onChange={()=> {
                            form.submit()
                        }}>
                            {t("registercenter.directorby")} &nbsp;
                            20{actualYear ?
                            (+actualYear) : 22}/20{(actualYear ?(+actualYear +1): 23)}
                             {t("registercenter.directoray")} &nbsp;
                            <a href={t("registercenter.directorurl")}
                               target={"_blank"}
                               className={"primaryLink"}>{t("registercenter.directorturl")}</a>
                        </Checkbox>
                    </Form.Item>

                </div>
                <div className={"form-item-mb-m"}>
                    <Form.Item
                        name="agreement"
                        valuePropName="checked"
                        rules={[
                            {
                                validator: (_, value) =>
                                    value ? Promise.resolve() : Promise.reject(new Error(t("registro.mustaccept"))),
                            },
                        ]}

                    >
                        <Checkbox onChange={()=> {
                            form.submit()
                        }}>
                            {t("registercenter.termburl")} &nbsp;
                            <a href={t("registercenter.termurl")}
                               target={"_blank"}
                               className={"primaryLink"}>{t("registercenter.termturl")}</a> &nbsp;
                            {t("registercenter.termaurl")} &nbsp;
                            <a href={t("registercenter.poliprivurl")}
                               target={"_blank"}
                               className={"primaryLink"}>{t("registercenter.poliprivturl")}</a>.
                        </Checkbox>
                    </Form.Item>

                </div>
                <div className={"form-item-mb-m"}>
                    <Form.Item
                        name="agreement1"
                        valuePropName="checked"
                        rules={[
                            {
                                validator: (_, value) =>
                                    value ? Promise.resolve() : Promise.reject(new Error(t("registro.mustaccept"))),
                            },
                        ]}

                    >
                        <Checkbox onChange={()=> {
                            form.submit()
                        }}>
                            {t("contrato.receiveinfo")}
                        </Checkbox>
                    </Form.Item>

                </div>
                <div className={"form-item-mb-m"}>
                    <Form.Item
                        name="agreement2"
                        valuePropName="checked"
                        rules={[
                            {
                                validator: (_, value) =>
                                    value ? Promise.resolve() : Promise.reject(new Error(t("registro.mustaccept"))),
                            },
                        ]}

                    >
                        <Checkbox onChange={()=> {
                            form.submit()
                        }}>
                            {t("registercenter.centrocompromete")}
                        </Checkbox>
                    </Form.Item>

                </div>
                <div className={"form-item-mb-m"}>
                    <Form.Item
                        name="agreement3"
                        valuePropName="checked"
                        rules={[
                            {
                                validator: (_, value) =>
                                    value ? Promise.resolve() : Promise.reject(new Error(t("registro.mustaccept"))),
                            },
                        ]}

                    >
                        <Checkbox onChange={()=> {
                            form.submit()
                        }}>
                            {t("registercenter.centrocompromete2")}
                        </Checkbox>
                    </Form.Item>
                </div>
                <div className={"form-item-mb-m"}>
                    <Form.Item
                        name="agreement4"
                        valuePropName="checked"
                        rules={[
                            {
                                validator: (_, value) =>
                                    value ? Promise.resolve() : Promise.reject(new Error(t("registro.mustaccept"))),
                            },
                        ]}

                    >
                        <Checkbox onChange={()=> {
                            form.submit()
                        }}>
                          {t("registercenter.declaro")}
                        </Checkbox>
                    </Form.Item>
                </div>
            </div>
        </Form>
            <div className={"centerClave"}>
                <p className={"customLabel"}>{t("registercenter.descargar")}</p>
                <p  dangerouslySetInnerHTML={{__html: t('registercenter.subdescargar')}} />
                {!isOk ?
                    <Button
                        onClick={()=>form.submit()}
                        onMouseOver={()=>form.submit()}
                        disabled={!isOk || !form.isFieldsTouched(true) ||
                            !!form.getFieldsError().filter(({ errors }) => errors.length).length} icon={<DownloadOutlined />}
                        className="primaryButton" type="primary">
                        {t("registercenter.descargar")}
                    </Button>
                    :
                    <RegisterPDFCenter year={year} ccaa={ccaa} download={downloadContract}
                                       user={user}
                                       center={props.center} courses={props.courses} values={props.values}/>
                }
            </div>

            <div className={"centerClave"}>
                <p className={"customLabel"} style={{marginTop: 16}}>{t("registercenter.subir")}</p>
                <p  dangerouslySetInnerHTML={{__html: t('registercenter.subirdesc')}} />
                    <div>
                        <Upload
                            beforeUpload={beforeUpload}
                            onChange={handleChangeImg}
                            onRemove={onRemove}
                            name="file"

                            action={config.backendUrl + "/v1/uploadcontract"}
                        >
                            <Button icon={<UploadOutlined />}  disabled={!isContract}   className="primaryButton" type="primary">{t("registercenter.subir")}</Button>
                        </Upload>
                    </div>

                {pdf &&
                    <div className={"buttons-pre-next"}>
                        <Button className="primaryButton buttonSizeS" onClick={() => props.goTo(props.values,1 )} htmlType="button">{t("atras")}</Button>
                        <Button
                            loading={loading}
                            onClick={() => saveCenter()}
                            className="primaryButton buttonSizeS" type="primary" htmlType="submit">
                            {t("registercenter.enviarc")}
                        </Button>
                    </div>

                }

            </div>
        </>
    )
}

export default withTranslation()(StepThreeCenter);
